import React from "react";
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  HStack,
  Stack,
  Text,
  Flex,
  Icon,
} from "@chakra-ui/react";
import { MdVideoLibrary } from "react-icons/md";
import Scene from "./Scene";
import CreateSceneModal from "../Modals/CreateSceneModal";

export default function Scenes({
  formErrors,
  generatedScenes,
  handleFormChange,
  handleGenerateSubmit,
  handleSaveDraft,
  handleSceneComplete,
  handleSelectScene,
  isGenerating,
  isModalOpen,
  onModalClose,
  onModalOpen,
  sceneForm,
  projectId,
}) {
  return (
    <>
      {/* Create Scene Button */}
      <HStack justifyContent="space-between" mb={6}>
        <Breadcrumb>
          <BreadcrumbItem isCurrentPage>
            <Text>Scenes</Text>
          </BreadcrumbItem>
        </Breadcrumb>

        <Button
          colorScheme="blue"
          leftIcon={<Icon as={MdVideoLibrary} />}
          onClick={onModalOpen}
          size="sm"
        >
          Create Scene
        </Button>
      </HStack>

      {/* Scene Generation Modal */}
      <CreateSceneModal
        formErrors={formErrors}
        handleFormChange={handleFormChange}
        handleGenerateSubmit={handleGenerateSubmit}
        handleSaveDraft={handleSaveDraft}
        isGenerating={isGenerating}
        isOpen={isModalOpen}
        onClose={onModalClose}
        sceneForm={sceneForm}
      />

      {/* Display the list of generated scenes */}
      <Box mb={6}>
        {generatedScenes.length === 0 ? (
          <Flex
            align="center"
            direction="column"
            h="50vh"
            justify="center"
            textAlign="center"
          >
            <Icon as={MdVideoLibrary} boxSize={16} color="gray.400" mb={4} />
            <Text color="gray.600" fontSize="lg" fontWeight="medium" mb={2}>
              No scenes generated yet
            </Text>
            <Text color="gray.500" maxW="md" mb={6}>
              Create your first scene to get started with your project
            </Text>
            <Button
              colorScheme="blue"
              leftIcon={<Icon as={MdVideoLibrary} />}
              onClick={onModalOpen}
              size="md"
            >
              Create Scene
            </Button>
          </Flex>
        ) : (
          <Stack mb={6} spacing={4}>
            {generatedScenes.map((scene) => (
              <Scene
                isPlaceholder={scene.isPlaceholder}
                jobId={scene.jobId}
                key={scene.scene_name}
                onSceneComplete={handleSceneComplete}
                onSelect={handleSelectScene}
                projectId={projectId}
                sceneId={scene.scene_name}
              />
            ))}
          </Stack>
        )}
      </Box>
    </>
  );
}
